export const imageType = [
  'image/png',
  'image/jpeg',
  'image/jpg',
  'jpeg',
  'jpg',
  'png',
  'svg',
];

export const imgAcceptTypeUpload = ['image/png', 'image/jpeg', 'image/jpg'];

export const videoAcceptTypeUpload = [
  'video/mp4',
  'video/avi',
  'video/quicktime',
  'video/x-quicktime',
  'video/msvideo',
  'video/x-msvideo',
];

export const recruitmentAcceptTypeUpload = [
  // pdf
  'application/pdf',
  // word
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
];

export const excelFileType = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
];

export const notImgAcceptTypeUpload = [
  // pdf
  'application/pdf',
  // word
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  // powerpoint
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ...excelFileType,
];

export const hashAccpetTypeUpload = {
  // pdf
  'application/pdf': 'application/pdf',
  // word
  'application/msword': 'application/doc',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
    'application/docx',
  // excel
  'application/vnd.ms-excel': 'application/xls',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
    'application/xlsx',
  // powerpoint
  'application/vnd.ms-powerpoint': 'application/ppt',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation':
    'application/pptx',
  // image
  'image/png': 'image/png',
  'image/jpeg': 'image/jpeg',
  'image/jpg': 'image/jpg',
  //video
  'video/mp4': 'video/mp4',
  'video/avi': 'video/avi',
  'video/msvideo': 'video/avi',
  'video/x-msvideo': 'video/avi',
  'video/quicktime': 'video/mov',
  'video/x-quicktime': 'video/mov',
};

export const reverseHashTypeUpload = {
  // image
  png: 'image/png',
  jpeg: 'image/jpeg',
  jpg: 'image/jpg',
  // pdf
  pdf: 'application/pdf',
  // word
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  // excel
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  // powerpoint
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  // video
  mp4: 'video/mp4',
  avi: 'video/avi',
  mov: 'video/quicktime',
};
